module.exports = __webpack_public_path__ + "static/media/7.dab55541.jpg";